import { PicklistDetailed } from './PicklistDetailed';

export default PicklistDetailed;
